import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { semanticMapJsonLd, serializeJsonLd } from "@/seo/semanticMap";

const semanticMapScript = document.getElementById("pcp-semantic-map");
if (semanticMapScript) {
  semanticMapScript.textContent = serializeJsonLd(semanticMapJsonLd);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
